import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

export const MASTER_LIST = [
  { key: "customers", path: "pelanggan", label: "Pelanggan", desc: "Kelola data pelanggan perusahaan." },
  { key: "suppliers", path: "pemasok", label: "Pemasok", desc: "Kelola data pemasok dan mitra manufaktur." },
  { key: "products", path: "produk", label: "Produk & SKU", desc: "Master produk dengan SKU, kategori, dan harga." },
  { key: "product_categories", path: "kategori-produk", label: "Kategori Produk", desc: "Kelompokkan produk berdasarkan kategori." },
  { key: "units", path: "satuan", label: "Satuan", desc: "Satuan penjualan dan berat produk." },
  { key: "warehouses", path: "gudang", label: "Gudang", desc: "Lokasi gudang utama, transit, dan mitra." },
  { key: "bank_accounts", path: "rekening-bank", label: "Rekening Bank", desc: "Rekening bank operasional perusahaan." },
  { key: "cash_accounts", path: "kas", label: "Kas", desc: "Kas utama, kas kecil, dan kas operasional." },
  { key: "currencies", path: "mata-uang", label: "Mata Uang", desc: "Mata uang yang digunakan sistem." },
  { key: "exchange_rates", path: "kurs", label: "Kurs Mata Uang", desc: "Kurs beli, jual, dan tengah per tanggal." },
  { key: "projects", path: "proyek", label: "Proyek", desc: "Data proyek dan pusat biaya proyek." },
  { key: "chart_of_accounts", path: "daftar-akun", label: "Daftar Akun (COA)", desc: "Bagan akun akuntansi perusahaan." },
  { key: "taxes", path: "pajak", label: "Pajak", desc: "Konfigurasi tarif dan jenis pajak." },
  { key: "document_numbering", path: "penomoran-dokumen", label: "Penomoran Dokumen", desc: "Format nomor dokumen otomatis." },
  { key: "opening_balances", path: "saldo-awal", label: "Saldo Awal", desc: "Migrasi saldo awal periode pembukuan." },
];

export default function MasterDataLayout() {
  return <div className="page-fade"><Outlet /></div>;
}
